import { render } from "./ExternalApiKeyPermissionsEditor.vue?vue&type=template&id=aa8b6b6a&scoped=true"
import script from "./ExternalApiKeyPermissionsEditor.vue?vue&type=script&lang=js"
export * from "./ExternalApiKeyPermissionsEditor.vue?vue&type=script&lang=js"

import "./ExternalApiKeyPermissionsEditor.vue?vue&type=style&index=0&id=aa8b6b6a&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa8b6b6a"]])

export default __exports__